module.exports = __webpack_public_path__ + "86768f75b8a8eb41c38e319c141bf71f.fbx";